import React, { FC } from 'react';
import { useStyles } from './styles';
import { AudioPlayerProps } from './interface';

export const AudioPlayer: FC<AudioPlayerProps> = ({ url, onPlay }) => {
  const classes = useStyles();

  return (
    <audio
      key={url}
      controls
      controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
      className={classes.audioPlayer}
      onPlaying={onPlay}
    >
      <source src={url} type="audio/mp3" />
    </audio>
  );
};
